export default __webpack_public_path__ + "6d715a8c3f30153178704cae2975e71b.woff2";